module.exports = __webpack_public_path__ + "static/img/课程资源建设平台学生端.c9556fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/课程资源建设平台学生端.png
// module id = Wk6J
// module chunks = 13